import styled from "styled-components";

import getStartedBg from './../../assets/images/static/footerBg.png';
import getStartedMob from './../../assets/images/static/getStartedMob.png';

export const BookDemoSection = styled.section`
  margin-top: 120px;
  min-height: 450px;
  position: relative;
  z-index: 9;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: 90px;
    min-height: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 0;
    min-height: 420px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 380px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 340px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 200px;
    padding: 0 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 150px;
    padding: 0 60px;
  }
`;

export const GetStarted = styled.div`
  background: url(${getStartedBg}) no-repeat top;
  background-size: cover;
  border-radius: ${({theme}) => theme.radius.medium};
  left: 50%;
  padding: 150px 100px;
  position: absolute;
  top: 120px;
  top: 60px;
  transform: translate(-50%, 0);
  width: 1400px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    border-radius: ${({theme}) => theme.radius.hdMedium};
    padding: 110px 90px;
    width: 1200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 500px;
    padding: 100px 85px;
    top: 175px;
    top: 80px;
    width: 1060px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.normal};
    height: 420px;
    padding: 80px 70px;
    top: 170px;
    top: 80px;
    width: 900px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 360px;
    padding: 68px 54px;
    top: 150px;
    top: 75px;
    width: 760px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    background: url(${getStartedMob}) no-repeat right top;
    background-size: 80%;
    background-color: ${({theme})=> theme.colors.secondary};
    height: 680px;
    padding: 52px 40px;
    top: 0;
    width: 80%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    background: url(${getStartedMob}) no-repeat right top;
    background-size: 115%;
    background-color: ${({theme})=> theme.colors.secondary};
    height: 600px;
    padding: 20px;
    width: 310px;
  }
`;

export const HeadingTitle = styled.h2`
  color: ${({theme}) => theme.colors.basic};
  margin-bottom: 32px;
  margin-left: 0;
  width: 500px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-family: "RubikLight";
    margin-bottom: 24px;
    width: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-bottom: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-bottom: 12px;
    width: 296px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    line-height: 40px;
    margin-bottom: 36px;
    margin-top: 340px;
    width: 120px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    line-height: 33px;
    margin-bottom: 30px;
    margin-top: 320px;
  }
  span {
    font-family: inherit;
    font-size: inherit;
  }
  &:before, &:after {
    content: none;
  }
`;

export const Strong = styled.strong`
  font-family: "RubikBold";
  font-size: inherit;
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    font-family: "RubikMedium";
  }
`;

export const DemoDetails = styled.span`
  color: ${({theme}) => theme.colors.basic};
  display: block;
  font-family: "RubikLight";
  line-height: ${({theme}) => theme.lineHeight.subHeight};
  margin-bottom: 56px;
  width: 540px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    margin-bottom: 44px;
    width: 480px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    line-height: ${({theme}) => theme.lineHeight.hdPrimaryHeight};
    margin-bottom: 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    margin-bottom: 28px;
    width: 360px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    line-height: ${({theme}) => theme.lineHeight.smallerHeight};
  }
`;

export const ButtonWrapper = styled.div``;

export const DefaultButton = styled.button`
  background-color: ${({theme}) => theme.colors.basic};
  font-family: "RubikMedium";
  margin-right: 20px;
  padding: 21px 24px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-right: 16px;
    padding: 18px 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 14px 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 12px 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 10px 14px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    display: block;
    margin-bottom: 20px;
    padding: 16px;
    width: 280px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-bottom: 16px;
    padding: 13px;
    width: 268px;
  }
`;

export const CallusButton = styled.button`
  border: 1px solid ${({theme}) => theme.colors.basic};
  color: ${({theme}) => theme.colors.basic};
  padding: 20px 56px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 16px 46px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 13px 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 11px 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 10px 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    display: block;
    padding: 14px;
    width: 280px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 12px;
    width: 268px;
  }
`;
